import type * as MatchesTypes from './reducers/matches/types';
import type * as ObjectsTypes from './reducers/objects/types';
import type * as SportsTypes from './reducers/sports/types';
import type * as StagesTypes from './reducers/stages/types';
import type * as StakesTypes from './reducers/stakes/types';
import type * as TournamentsTypes from './reducers/tournaments/types';
import type * as UnionsTypes from './reducers/unions/types';

import { createEntitiesReducer, createMenuReducer } from './createReducers';
import { createImmutableObjects } from './reducers/matches/utils/immutable-structures';
import type * as MatchLinesTypes from './reducers/matches/utils/match-lines';
import type * as BackendEntitiesTypes from './reducers/types/backendEntities';
import { Topic } from './reducers/types/backendEntities';
import type * as BettingRootReducerTypes from './reducers/types/bettingRootReducer';
import type * as BettingEntitiesSelectorsTypes from './selectors';

// ---

export * from './reducers/matches/constants';
export {
  Topic,
  createImmutableObjects,
  createEntitiesReducer,
  createMenuReducer,
};

export type BettingEntitiesSelectors = BettingEntitiesSelectorsTypes.BettingEntitiesSelectors;

export type BackendEntitiesDiff = BackendEntitiesTypes.BackendEntitiesDiff;
export type BackendEntities = BackendEntitiesTypes.BackendEntities;

export type RecordOfBettingEntitiesState = BettingRootReducerTypes.RecordOfBettingEntitiesState;
export type SSRBettingEntitiesState = BettingRootReducerTypes.SSRBettingEntitiesState;

export type StakesState = StakesTypes.StakesState;
export type RecordOfStakeEntity = StakesTypes.RecordOfStakeEntity;
export type SSRStakesState = StakesTypes.SSRStakesState;
export type BackendStakes = StakesTypes.BackendStakes;
export type BackendStake = StakesTypes.BackendStake;
export type BetsState = StakesTypes.BetsState;
export type RecordOfBetEntity = StakesTypes.RecordOfBetEntity;
export type SSRBetsState = StakesTypes.SSRBetsState;
export type BackendBets = StakesTypes.BackendBets;
export type BackendBet = StakesTypes.BackendBet;

export type BackendObjects = ObjectsTypes.BackendObjects;
export type RecordOfObjectsState = ObjectsTypes.RecordOfObjectsState;
export type RecordOfObjectEntity = ObjectsTypes.RecordOfObjectEntity;

export type BackendPeriod = MatchesTypes.BackendPeriod;
export type BackendPeriods = MatchesTypes.BackendPeriods;
export type RecordOfPeriod = MatchesTypes.RecordOfPeriod;

export type BackendScores = MatchesTypes.BackendScores;
export type ScoresEntity = MatchesTypes.ScoresEntity;
export type ScoresPartOfGameEntity = MatchesTypes.ScoresPartOfGameEntity;
export type ScoresPeriodsEntity = MatchesTypes.ScoresPeriodsEntity;
export type ScoresEntityByTeamId = MatchesTypes.ScoresEntityByTeamId;

export type BackendTimer = MatchesTypes.BackendTimer;

export type MatchObjects = BettingEntitiesSelectorsTypes.MatchObjects;
export type BackendMatch = MatchesTypes.BackendMatch;
export type BackendMatches = MatchesTypes.BackendMatches;
export type RecordOfMatchesState = MatchesTypes.RecordOfMatchesState;
export type RecordOfMatchEntity = MatchesTypes.RecordOfMatchEntity;
export type LineEntryResult = MatchLinesTypes.LineEntryResult;
export type MatchEntryResult = MatchLinesTypes.MatchEntryResult;

export type BackendSport = SportsTypes.BackendSport;
export type BackendSports = SportsTypes.BackendSports;
export type RecordOfSportEntity = SportsTypes.RecordOfSportEntity;
export type SportEntityNative = SportsTypes.SportEntityNative;
export type RecordOfSportsState = SportsTypes.RecordOfSportsState;

export type BackendUnion = UnionsTypes.BackendUnion;
export type BackendUnions = UnionsTypes.BackendUnions;
export type RecordOfUnionEntity = UnionsTypes.RecordOfUnionEntity;
export type UnionEntityNative = UnionsTypes.UnionEntityNative;
export type RecordOfUnionsState = UnionsTypes.RecordOfUnionsState;

export type BackendTournament = TournamentsTypes.BackendTournament;
export type BackendTournaments = TournamentsTypes.BackendTournaments;
export type RecordOfTournamentEntity = TournamentsTypes.RecordOfTournamentEntity;
export type TournamentEntityNative = TournamentsTypes.TournamentEntityNative;
export type RecordOfTournamentsState = TournamentsTypes.RecordOfTournamentsState;

export type BackendStage = StagesTypes.BackendStage;
export type BackendStages = StagesTypes.BackendStages;
export type RecordOfStageEntity = StagesTypes.RecordOfStageEntity;
export type StageEntityNative = StagesTypes.StageEntityNative;
export type RecordOfStagesState = StagesTypes.RecordOfStagesState;
